// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"31d6cfe0","281":"3b3639cf","446":"3ef809a9","530":"e4ab5dfd","644":"e6c598d1","748":"df1d0e6a"}[chunkId] + ".chunk.css";
};